import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { NotifyType } from '../../../../../../core/enums/NotifyType';
import { IItemCatalog, IItemCatalogBody, IMasterData } from '../../../../../../core/models';
import { AdminService } from '../../../../../../core/services/admin.service';
import { AppNotifyService } from '../../../../../../core/services/app-notify.service';
import { MasterDataService } from '../../../../../../core/services/master-data.service';
import { PriceBookService } from '../../../../../../core/services/price-book.service';
import { UserService } from '../../../../../../core/services/user.service';

@Component({
  selector: 'app-add-item',
  templateUrl: './add-item.component.html',
  styleUrls: ['./add-item.component.scss']
})
export class AddItemComponent implements OnInit {
  itemId: number = 0;
  editItem: IItemCatalog;
  public priceBookCategories: IMasterData[] = [];
  public associatedCategories: IMasterData[] = [];
  public itemFinishes: IMasterData[] = []; 
  public mode: string = "Add Item";
  public saveButtonText: string = "Add";
  public isExcludeDescriptionFromUpdate_disable: boolean = false;
  public isExcludeBasePriceFromUpdate_disable: boolean = false;
  public getCountrys: any = [{ countryCode: '' }, { countryCode: 'CA' }, { countryCode: 'US' }];
  public maxChars = 120;  //setting maxlength of adminnote textarea
  public commentslength: number = 0;
  //feetVsRollData = [];
  //itemTypeData = [];
  //#region  constructor & ngOnInit
  constructor(private userService: UserService,
    private masterService: MasterDataService,
    private appNotifyService: AppNotifyService,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private adminService: AdminService,
    private priceBookService: PriceBookService  ) {
  }

  ngOnInit(): void {
    // alert(this.item.itemMaster.itemNumber.value);
    
   
    this.route.queryParams.subscribe(params => {
      if (params['id']) {
        this.itemId = params['id'];
      }
    });
    if (this.itemId > 0) {
      if (this.adminService.itemCatalogData.length > 0) {

        this.editItem = this.adminService.itemCatalogData.find(i => i.id == this.itemId);
      }
      if (this.editItem) {
        this.mode = "Edit Item";
        this.saveButtonText = "Update";
        this.item.itemMaster.itemNumber.value = this.editItem.itemNumber;
        this.item.itemMaster.longItemNumber.value = this.editItem.longItemNumber;
        this.item.descriptions.shortDescription.value = this.editItem.shortDescription;
        this.item.descriptions.longDescription.value = this.editItem.fullDescription;
        this.item.itemMaster.size.value = this.editItem.size;
        //this.item.descriptions.description1.value = //this.editItem.description1;--finish description
        this.item.descriptions.description1.value = this.editItem.description2;
        this.item.descriptions.description2.value = this.editItem.description3;
        //this.item.itemMaster.finish.value.value = this.editItem.finishValue;
        this.bindAndSetFinishes(this.editItem.finishValue);
        this.item.images.thumbnailPicture.value = this.editItem.thumbNailPicture;
        this.item.images.actualPicture.value = this.editItem.actualPicture;
        this.item.itemMaster.basePrice.value = this.editItem.basePrice;
        this.bindAndSetPriceBookCategories(this.editItem.priceBookCategoryId);
        this.item.itemMaster.canBeOrderedOnline.value = this.editItem.canPlaceOrder;
        this.item.itemMaster.isActive.value = this.editItem.isActive;
        this.item.itemMaster.isExcludeDescriptionFromUpdate.value = this.editItem.excludedInNightJob;
        this.item.itemMaster.isExcludeBasePriceFromUpdate.value = this.editItem.excludedPriceUpdateInNightJob;
        this.item.itemMaster.effectiveFrom.value = this.editItem.effectiveFrom;
        this.item.itemMaster.effectiveTo.value = this.editItem.effectiveTo;
        this.item.images.additionalImages.value = this.editItem.additionalImage;
        this.item.itemMaster.manuallyAddedDonotTouch.value = this.editItem.manuallyAddedDonotTouch;
        this.item.itemMaster.v6FinishCode.value = this.editItem.v6FinishCode;
        this.item.itemMaster.isExcludeWeightFromUpdate.value = this.editItem.excludedWeightUpdateInNightJob;
        this.item.itemMaster.isExcludePSCFromUpdate.value = this.editItem.excludedPSCUpdateInNightJob;
        this.item.itemMaster.weight.value = this.editItem.weight;
        this.item.itemMaster.psc.value = this.formatPSCValue(this.editItem.psc);
        this.item.itemMaster.countryCode.value = this.editItem.countryCode;
        this.item.itemMaster.adminNote.value = this.editItem.adminNote;
      }
      else {
        this.router.navigate(['/itemAdministration']);
      }
    }
    else {
      this.bindAndSetPriceBookCategories(0);
      this.bindAndSetFinishes(null);
    }
  }
   formatPSCValue(value: string) {
    if (value == '0') {
      value = '';
    } else if (value.length == 1) {
      value = '00' + value;
    }
    else if (value.length == 2) {
      value = '0' + value;
    }
    return value;
  }

  bindAndSetPriceBookCategories(catId: number) {
    //#region GetPriceBook Categories
    this.priceBookService.getAllCategories().subscribe(c => {
      this.priceBookCategories = c;
      if (catId > 0) {
        this.item.itemMaster.category.value = this.priceBookCategories.find(c => c.value === catId.toString());
        this.item.itemMaster.categoryDescription.value = this.item.itemMaster.category.value.name;
        this.associatedCategories = this.priceBookCategories.filter(c => c.value != catId.toString());
        // this.item.itemMaster.associatedCategory.value.push(this.priceBookCategories.find(c => c.value === '9'));
        this.getAssociatedCategories(this.item.itemMaster.longItemNumber.value);
      }
      else {
        this.associatedCategories = this.priceBookCategories;
      }
    });
    //#endregion
    //this.associatedCategories = [
    //  { value: "LeedPreSubmittalDocumentation", name: 'LEED v4 Building Design & Construction' },
    //  { value: "", name: '' },
    //];
  }

  bindAndSetFinishes(finishValue: string) {
    this.masterService.getFinishes().then(r => {
      this.itemFinishes = r;
      this.itemFinishes = this.itemFinishes.filter(f => f.value != null);
      this.itemFinishes.push({ name: 'None', value: null });
      if (finishValue) {
        this.item.itemMaster.size.disabled = false
        if (finishValue === "00") {
          this.item.itemMaster.finish.value = { name: '00 (No Finish)', value: '00' }
        }
        else {
          this.item.itemMaster.finish.value = this.itemFinishes.find(c => c.value === finishValue);
        }
      }
    });
  }
  getAssociatedCategories(longItemNumber: string) {
    this.priceBookService.getAssociatedCategories(longItemNumber).subscribe(c => {
      this.item.itemMaster.associatedCategory.value = c;
    });
  }
  //#endregion  
  //#region Member Variables & getters & Setters
  item = {
    itemMaster: {
      itemNumber: {
        label: "Item Number",
        value: "",
        valid: true
      },
      longItemNumber: {
        label: "Long Item Number",
        value: ""
      },
      //finish: {
      //  label: "Finish",
      //  value: ""
      //},
      finish: {
        label: "Finish",
        value: { "value": null, 'name': "Select Finish" }
      },
      size: {
        label: "Size",
        value: "",
        disabled: true
      },
      weight: {
        label: "weight",
        value: ""
      },
      psc: {
        label: "PSC",
        value: ""
      },
      feetVsRoll: {
        label: "Feet vs. Roll",
        value: { "key": 'Feet', 'value': 1 },
        data: [{ "key": 'Feet', 'value': 1 }, { "key": 'Roll', 'value': 2 }]
      },
      
      effectiveFrom: {
        label: "Effective From",
        value: null//new Date() //"MM/DD/YYYY"  //TODAY's DATE
      },
      effectiveTo: {
        label: "Effective To",
        value: null//new Date() // "MM/DD/YYYY"  //TODAY's DATE
      },     
      basePrice: {
        label: "Base Price",
        value: "0",
        valid: true
      },
      canBeOrderedOnline: {
        label: "Can Be Ordered Online",
        value: true
      },
      isActive: {
        label: "IsActive",
        value: true
      },
      isExcludeDescriptionFromUpdate: {
        label: "Don't update Descriptions in Night Job Run",
        value: false
      },
      isExcludeBasePriceFromUpdate: {
        label: "Don't update Base Price in Night Job Run",
        value: false
      },
      isExcludeWeightFromUpdate: {
        label: "Don't update Weight in Night Job Run",
        value: false
      },
      isExcludePSCFromUpdate: {
        label: "Don't update PSC in Night Job Run",
        value: false
      },
      manuallyAddedDonotTouch: {
        label: "Manually added item - Don't touch",
        value: false
      },
      associatedCategory: {
        label: "Category Associations",
        value: []
      },
      countryCode: {
        label: "Country Code",
        value: ""
      },
      adminNote: {
        label: "Admin Note",
        value: "",
        characterRemainingLbl: 'Characters Remaining',
      },
      //minimumQuantityToOrder: {
      //  label: "Minimum Quantity To Order",
      //  value: "1"
      //},
      //maximumQuantityToOrder: {
      //  label: "	Maximum Quantity To Order",
      //  value: "99999"
      //},      
      sellingUnitofMeasure: {
       // data: [],
        label: "Unit of Measure",
        value: { "key": 'EA', 'value': 'EA' },
        data: [{ "key": 'EA', 'value': 'FT' }, { "key": 'FT', 'value': 'FT' }]
      },
      //itemType: {
      //  label: "Item Type",
      //  value: { "name": 'Select Item', 'value': null },
      //  data: [{ "name": 'Item1', 'value': 1 }, { "name": 'Item2', 'value': 2 }]
      //},
      category: {
        label: "Category Name",
        value: { "value": null, 'name': "Select Category" }
      },
      categoryDescription: {
        label: "Price Book Category Description",
        value: ""
      },
      v6FinishCode: {
        label: "V6FinishCode",
        value: ""
      }
    },
    descriptions: {
      shortDescription: {
        label: "Short Description",
        value: ""
      },
      longDescription: {
        label: "Long Description",
        value: ""
      },
      description1: {
        label: "Description 1",
        value: ""
      },
      description2: {
        label: "Description 2",
        value: ""
      },
        //description3: {
        //  label: "Description 3",
        //  value: ""
        //},
      //description4: {
      //  label: "Description 4",
      //  value: ""
      //},
      //description5: {
      //  label: "Description 5",
      //  value: ""
      //}
    },
    images: {
      thumbnailPicture: {
        label: "Thumbnail Picture",
        value: ""
      },
      actualPicture: {
        label: "Actual Picture",
        value: ""
      },
      additionalImages: {
        label: "Additional Images",
        value: ""
      }
    },
  }
  commenttxtArea(event) {
    this.commentslength = event.target.value.length;
  }

  onChangemanuallyAddedDonotTouch(e): void {
   
    if (e == true) {
      this.item.itemMaster.isExcludeBasePriceFromUpdate.value = true;
      this.item.itemMaster.isExcludeDescriptionFromUpdate.value = true;
      this.isExcludeDescriptionFromUpdate_disable = true;
      this.isExcludeBasePriceFromUpdate_disable = true;
    }
    else {
      this.item.itemMaster.isExcludeBasePriceFromUpdate.value = false;
      this.item.itemMaster.isExcludeDescriptionFromUpdate.value = false;
      this.isExcludeDescriptionFromUpdate_disable = false;
      this.isExcludeBasePriceFromUpdate_disable = false;
    }
  }
  //#endregion
   //#region Page Events
  addItem(): void {
    if (!this.validateAddItemForm()) {
      return;
    }
    const body: IItemCatalogBody = {
      id: Number(this.itemId),
      jdeItemId: '',
      itemNumber: this.item.itemMaster.itemNumber.value,
      longItemNumber: this.item.itemMaster.longItemNumber.value,
      shortDescription: this.item.descriptions.shortDescription.value,
      fullDescription: this.item.descriptions.longDescription.value,
      size: this.item.itemMaster.size.value,
      description1: (this.item.itemMaster.finish.value.value) ? this.item.itemMaster.finish.value.name : "00 (No Finish)",//finish desc from dropdown // Condition for Component Item Null Finish
      description2: this.item.descriptions.description1.value,
      description3: this.item.descriptions.description2.value,
      finishValue: this.item.itemMaster.finish.value.value,
      itemType: 1,
      thumbNailPicture: this.item.images.thumbnailPicture.value,
      actualPicture: this.item.images.actualPicture.value,
      basePrice: this.item.itemMaster.basePrice.value,
      priceBookCategoryDescription: this.item.itemMaster.category.value.name,
      priceBookCategoryId: Number(this.item.itemMaster.category.value.value),
      canPlaceOrder: this.item.itemMaster.isActive.value ? this.item.itemMaster.canBeOrderedOnline.value : false,
      isActive: this.item.itemMaster.isActive.value,
      excludedInNightJob: this.item.itemMaster.isExcludeDescriptionFromUpdate.value,
      excludedPriceUpdateInNightJob: this.item.itemMaster.isExcludeBasePriceFromUpdate.value,
      manuallyAddedDonotTouch: this.item.itemMaster.manuallyAddedDonotTouch.value,
      v6FinishCode:this.item.itemMaster.v6FinishCode.value,
      addedBy: this.userService.readUserObject.userName,
      effectiveFrom: this.item.itemMaster.effectiveFrom.value,
      effectiveTo: this.item.itemMaster.effectiveTo.value,
      additionalImage: this.item.images.additionalImages.value,
      associatedCategories: Array.prototype.map.call(this.item.itemMaster.associatedCategory.value, s => s.value).toString(), // "A,B,C"
      weight:Number( this.item.itemMaster.weight.value),
      psc: this.item.itemMaster.psc.value,
      excludedWeightUpdateInNightJob: this.item.itemMaster.isExcludeWeightFromUpdate.value,
      excludedPSCUpdateInNightJob: this.item.itemMaster.isExcludePSCFromUpdate.value,
      countryCode: this.item.itemMaster.countryCode.value,
      adminNote: this.item.itemMaster.adminNote.value
    }
    this.adminService.AddItemCatalog(body).subscribe((response: any) => {
      if (response) {
        console.log(response)
        if (body.id > 0) {
          this.appNotifyService.notify(NotifyType.SUCCESS, "Data updated Successfully.");
        }
        else {
          this.appNotifyService.notify(NotifyType.SUCCESS, "Item Created Successfully.");
        }
      }
      else {
        this.appNotifyService.notify(NotifyType.ERROR, "Error on saving data");
      }
    });
    
  }
  cancel(): void {
    this.appNotifyService.notify(NotifyType.INFO, "Operation is Canceled");
    this.router.navigate(['../'], { relativeTo: this.route });
  }
    //#endregion

  createLongItemNumber() {
    if (this.item.itemMaster.itemNumber) {
      this.item.descriptions.longDescription.value = this.item.itemMaster.itemNumber.value + "-"
        + ((this.item.descriptions.shortDescription && this.item.descriptions.shortDescription.value) ? this.item.descriptions.shortDescription.value : "");
      this.item.itemMaster.longItemNumber.value = this.item.itemMaster.itemNumber.value;
      if (this.item.itemMaster.finish.value && this.item.itemMaster.finish.value.value) {
        this.item.itemMaster.longItemNumber.value = this.item.itemMaster.itemNumber.value +
          "-" + this.item.itemMaster.finish.value.value
      }
      if (this.item.itemMaster.size.value) {
        this.item.itemMaster.longItemNumber.value = this.item.itemMaster.itemNumber.value +
          "-" + this.item.itemMaster.finish.value.value +
          "-" + this.item.itemMaster.size.value;
      }
    }
    
  }
  createLongDesc() {
    if (this.item.itemMaster.itemNumber) {
      this.item.descriptions.longDescription.value = this.item.itemMaster.itemNumber.value + "-"
        + ((this.item.descriptions.shortDescription && this.item.descriptions.shortDescription.value) ? this.item.descriptions.shortDescription.value : "");
    }
  }
  finishSelected(fin) {
    if (fin) {
      this.item.itemMaster.size.disabled = false;
    }
  }
  public validateAddItemForm(): boolean {
    let isValid = true;
    if (this.item.itemMaster.itemNumber.value && this.item.itemMaster.itemNumber.value.length > 0) {
      this.item.itemMaster.itemNumber.valid = true;
    } else {
      this.item.itemMaster.itemNumber.valid = false;
      isValid = false;
    }
    if (this.item.itemMaster.basePrice.value && +this.item.itemMaster.basePrice.value > 0) {
      this.item.itemMaster.basePrice.valid = true;
    } else {
      this.item.itemMaster.basePrice.valid = false;
      isValid = false;
    }
    return isValid;
  }

  setBasePriceLock(baseLock: boolean) {
    this.item.itemMaster.isExcludeBasePriceFromUpdate.value = baseLock;
  }
  setShortDescriptionLock(descLock: boolean) {
    this.item.itemMaster.isExcludeDescriptionFromUpdate.value = descLock;
  }
  setWeightLock(weightLock: boolean) {
    this.item.itemMaster.isExcludeWeightFromUpdate.value = weightLock;
  }
  setPSCLock(pscLock: boolean) {
    this.item.itemMaster.isExcludePSCFromUpdate.value = pscLock;
  }

}
